import React, { useState } from "react";
import { makeStyles } from "@mui/styles";
import {
  TextField,
  Button,
  MenuItem,
  Typography,
  Paper,
  Grid,
  FormControl,
  InputLabel,
  Select,
} from "@mui/material";
import styled from "styled-components";
import emailjs from "@emailjs/browser"; // Import EmailJS

const useStyles = makeStyles((theme) => ({
  container: {
    width: "100%",
    maxWidth: "1200px",
    margin: "40px auto",
    padding: theme.spacing(4),
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(2),
    },
  },
  header: {
    fontWeight: "bold",
    fontFamily: "Arial, sans-serif",
    color: "#333",
    marginBottom: theme.spacing(2),
    textAlign: "center",
  },
}));

const CTAButton = styled.button`
  background-color: #000;
  color: #fff;
  padding: 0.75rem 2rem;
  font-size: 1rem;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: #4a4a4a;
  }
`;

const ContactUsForm = () => {
  const classes = useStyles();
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    interest: "",
    query: "",
  });

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = (event) => {
    event.preventDefault();
  
    // Prepare common template parameters for EmailJS
    const templateParams = {
      name: formData.name,
      email: formData.email,
      phone: formData.phone,
      interest: formData.interest,
      query: formData.query,
      reply_to: formData.email,
    };
    const serviceId = process.env.REACT_APP_EMAILJS_SERVICE_ID;
    const templateId = process.env.REACT_APP_EMAILJS_TEMPLATE_ID;
    const publicKey = process.env.REACT_APP_EMAILJS_PUBLIC_KEY;
    const adminEmail = process.env.REACT_APP_ADMIN_EMAIL;
    // Send email to Admin using the "rasynth" service
    emailjs
      .send(
        serviceId, // Admin service ID
        templateId, // Template ID (assumed same for both)
        { ...templateParams, to_email: adminEmail },
        publicKey // Your EmailJS user/public key
      )
      .then(
        (resultAdmin) => {
          console.log("Admin email successfully sent!", resultAdmin.text);
          setFormData({
            name: "",
            email: "",
            phone: "",
            interest: "",
            query: "",
          });
        },
        (error) => {
          console.error("Error sending admin email:", error.text);
        }
      );
  
    // Send email to Tech using the "rasynth_tech" service
   
  };
  

  return (
    <Paper sx={{ backgroundColor: "white" }} className={classes.container} elevation={2}>
      <Typography
        variant="h4"
        className={classes.header}
        sx={{ fontSize: { xs: "1.5rem", sm: "2rem", md: "2.5rem" } }}
      >
        Reach Out To Us
      </Typography>
      <form onSubmit={handleSubmit}>
        {/* Row 1: Name and Email */}
        <Grid container spacing={2} mt={1} mb={0}>
          <Grid item xs={12} sm={6}>
            <TextField
              name="name"
              label="Enter Name"
              variant="outlined"
              required
              fullWidth
              InputProps={{ style: { height: 50 } }}
              value={formData.name}
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              name="email"
              label="Enter Email ID"
              variant="outlined"
              type="email"
              required
              fullWidth
              InputProps={{ style: { height: 50 } }}
              value={formData.email}
              onChange={handleChange}
            />
          </Grid>
        </Grid>

        {/* Row 2: Phone and Interest */}
        <Grid container spacing={2} sx={{ mt: 0 }}>
          <Grid item xs={12} sm={6}>
            <TextField
              name="phone"
              label="Enter Phone Number"
              variant="outlined"
              type="tel"
              required
              fullWidth
              InputProps={{ style: { height: 50 } }}
              value={formData.phone}
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <FormControl fullWidth size="small">
              <InputLabel id="interest-label">What are you interested in?</InputLabel>
              <Select
                labelId="interest-label"
                id="interest-select"
                name="interest"
                value={formData.interest}
                onChange={handleChange}
                label="What are you interested in?"
                sx={{ height: 50 }}
              >
                <MenuItem value="">
                  <em>
                    <br />
                  </em>
                </MenuItem>
                <MenuItem value="software services">Software & AI services</MenuItem>
                <MenuItem value="products">Our product</MenuItem>
                <MenuItem value="digital service">Digital service</MenuItem>
                <MenuItem value="talent aquisition">Talent acquisition service</MenuItem>
              </Select>
            </FormControl>
          </Grid>
        </Grid>

        {/* Row 3: Query (textarea) */}
        <Grid container spacing={2} sx={{ mt: 2 }}>
          <Grid item xs={12}>
            <TextField
              name="query"
              label="Briefly describe your query (If any)"
              variant="outlined"
              required
              fullWidth
              multiline
              rows={4}
              InputProps={{ style: { height: 100 } }}
              value={formData.query}
              onChange={handleChange}
            />
          </Grid>
        </Grid>

        {/* Row 4: Submit Button (Centered, not full width) */}
        <Grid container spacing={2} sx={{ mt: 2 }} justifyContent="center">
          <Grid item>
            <CTAButton type="submit">
              Contact Us
            </CTAButton>
          </Grid>
        </Grid>
      </form>
    </Paper>
  );
};

export default ContactUsForm;
